<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <!-- <a-form-item label="所属部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sysOrgCode', validatorRules.sysOrgCode]" placeholder="请输入所属部门"></a-input>
        </a-form-item> -->
        <a-form-item label="员工姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            @click="openAddUser"
            :disabled="isDisableUserName"
            v-decorator="['employeeName', validatorRules.employeeName]"
          ></a-input>
        </a-form-item>
        <a-form-item label="成员ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input @click="openAddUser" v-decorator="['employeeId', validatorRules.employeeId]" disabled></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="领导ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['leadId', validatorRules.leadId]" disabled></a-input>
        </a-form-item>
        <a-form-item label="领导名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input @click="openAddLead" v-decorator="['leadName', validatorRules.leadName]"></a-input>
        </a-form-item>

        <!-- <a-form-item label="员工ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'employeeId', validatorRules.employeeId]" placeholder="请输入员工ID"></a-input>
        </a-form-item>
        <a-form-item label="已结项目钱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'settlementMoney', validatorRules.settlementMoney]" placeholder="请输入已结项目钱" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="余额" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'balance', validatorRules.balance]" placeholder="请输入余额" style="width: 100%"/>
        </a-form-item> -->
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch checked-children="激活" un-checked-children="禁用" v-model="model.status" />
        </a-form-item>
      </a-form>
    </a-spin>
    <select-lead-modal ref="SelectLeadModal" :onlySelectOne="true" @selectChoosed="selectleadOK"></select-lead-modal>
    <select-user-modal ref="SelectUserModal" :onlySelectOne="true" @selectChoosed="selectOK"></select-user-modal>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import SelectLeadModal from './SelectLeadModal'
import SelectUserModal from './SelectUserModal'

export default {
  name: 'BusDailyStaffModal',
  components: {
    SelectLeadModal,
    SelectUserModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        sysOrgCode: { rules: [] },
        leadId: { rules: [ ] },
        leadName: { rules: [{ required: true, message: '请输入领导名称' }] },
        employeeId: { rules: [{ validator: (rule, value, callback) => validateDuplicateValue('bus_daily_staff', 'employee_id', value, this.model.id, callback)}] },
        settlementMoney: { rules: [] },
        balance: { rules: [] },
        remark: { rules: [] },
        employeeName: { rules: [{ required: true, message: '请输入员工名称' }] },
        
      },
      url: {
        add: '/dailyproject/busDailyStaff/add',
        edit: '/dailyproject/busDailyStaff/edit',
      },
      isDisableUserName: true,
    }
  },
  created() {},
  methods: {
    add() {
      this.isDisableUserName = false
      this.edit({ status: 1 })
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      console.log(this.model)
      if (this.model.status === 1) {
        this.model.status = true
      } else {
        this.model.status = false
      }
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'leadId', 'leadName', 'employeeId', 'remark', 'employeeName', 'status')
        )
      })
    },
    close() {
      this.$emit('close')
      this.isDisableUserName = true
      this.visible = false
    },
    openAddUser() {
      this.$refs.SelectUserModal.add()
    },
    openAddLead() {
      this.$refs.SelectLeadModal.add()
    },
    selectleadOK(selectData) {
      this.form.setFieldsValue({
        leadName: selectData[0].realname,
        leadId: selectData[0].username,
      })
    },
    selectOK(selectData) {
      this.form.setFieldsValue({
        employeeName: selectData[0].realname,
        employeeId: selectData[0].username,
      })
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.employeeId) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          if (this.model.status === true) {
            values.status = 1
          } else if (this.model.status === false) {
            values.status = 0
          }
          let formData = Object.assign({ id: this.model.id }, pick(values, 'leadId', 'status', 'remark', 'employeeId'))
          console.log('表单提交数据', formData)
          if (formData.employeeId === formData.leadId) {
            that.$message.error('员工和领导不能为同一个人');
            that.confirmLoading = false
          } else {
            httpAction(httpurl, formData, method)
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
                that.close()
              })
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>